export default __webpack_public_path__ + "static/media/img-ovato-meetups-2-new.736be910.png";